import moment from 'moment'

moment.updateLocale('en', {
  week: {
    dow: 1,
    doy: 4,
  },
})

export const getDateString = (date: Date): string => {
  return moment(date).format('YYYY-MM-DD')
}

export const parseDate = (dateString: string): Date => {
  return moment(dateString, 'YYYY-MM-DD').toDate()
}

export const isToday = (dateString: string): boolean => {
  return moment(dateString, 'YYYY-MM-DD').isSame(moment(), 'day')
}

export const formatDisplayDate = (dateString: string): string => {
  if (isToday(dateString)) return 'Today'
  return moment(dateString, 'YYYY-MM-DD').format('MMM D, YYYY')
}

export const getTodayDateString = (): string => {
  return moment().format('YYYY-MM-DD')
}
